import React from "react";
import "./LoadingSpinner.css"; // Import your loading spinner CSS for styling

const LoadingSpinner = () => {

  return (
    <div className="loading-spinner-container" style={{
      fontFamily: "Norwester, sans-serif",
      textTransform: "uppercase",
      fontWeight: "normal",
    }}>
      <div>
        <div class="loader"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;